import { Chip } from "@mui/material";

/**
 * Same StatusChip DiscoveryV2/Reporting/DiscoveryReportingModal.js's own
 * report history uses, verbatim — a real MUI Chip with the theme's
 * success/error/warning colors, not a custom-colored badge, so status reads
 * identically everywhere a report's status shows (this table, the single
 * "latest report" row, and any future module's own report list).
 */
export default function ReportStatusChip({ status }) {
  const s = String(status || "").toLowerCase();
  if (s === "completed" || s === "success") return <Chip label="Completed" color="success" size="small" />;
  if (s === "failed" || s === "error") return <Chip label="Failed" color="error" size="small" />;
  return <Chip label="In Progress" color="warning" size="small" />;
}
